import { useQuery } from "@tanstack/react-query";
import { getUserPoints } from "../../api/points";
import { useGuestProfile } from "../profile";
import { useSelector } from "react-redux";
import { brand } from "../../context";

export const useLiveCurrentPoints = () => {
  const guestprofile = useGuestProfile();
  const guest_crm_uid = guestprofile?.uuid;

  const { data } = useQuery({
    queryKey: ["points", guest_crm_uid],
    queryFn: () => getUserPoints({ guest_crm_uid }),
  });

  const availablePoints = (data?.data?.results ?? []).reduce(
    (a, b) => a + parseFloat(b.amount),
    0
  );

  return { availablePoints };
};

export function useEnoughPointsToBook({ price }) {
  const { withPoints } = useSelector((state) => ({
    withPoints: state.WebsiteMetadata?.metadata?.points_scheme ?? false,
  }));

  const { availablePoints } = useLiveCurrentPoints();
  var canBook = true;
  var priceDiff = 0;
  if (withPoints) {
    canBook = price < availablePoints;
    if (!canBook) {
      priceDiff = price - availablePoints;
    }
  }

  if (brand === "travily") canBook = true;

  return { priceDiff, canBook };
}
